import { render, staticRenderFns } from "./LearnerRegistrationResultsPage.vue?vue&type=template&id=bb40c212"
import script from "./LearnerRegistrationResultsPage.vue?vue&type=script&lang=js"
export * from "./LearnerRegistrationResultsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports